var url = "5f5f4af7a7b17f29f9bbd18f6a1a62ea.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;